import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultAchievementModel = {
  search: CreateCommonSearchContext(),
  edit: {
    editForm: {
      model: {} as AchievementEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<AchievementEditCriteria>,
}

export interface AchievementEditCriteria {
  achieve_Id: number;
  mileage: number;
  cylinder: number;
  achieveDate: string;
}
